import {AvailableAppointment, Time} from '../models/appointment.model';
import {monthYearRange} from './time-helpers.service';

export const convertAppointments = (data: AvailableAppointment[]): AvailableAppointment[] => {
	return data.filter((appointment: AvailableAppointment) => appointment.time.length);
};

export const getAppointmentTimesByDate = (date: string, availableAppointments: AvailableAppointment[]): Time[] => {
	if (!date || !availableAppointments.length) {
		return [];
	}
	const times = availableAppointments.find(appointment => appointment.date === date)?.time || [];
	return sortedAppointmentTimes(times);
};

const sortedAppointmentTimes = (times: Time[]): Time[] => {
	return times.sort((a, b) => {
		const [hourA, minuteA] = a.time.split(':').map(Number);
		const [hourB, minuteB] = b.time.split(':').map(Number);
		return hourA - hourB || minuteA - minuteB;
	});
};

export const monthYearTitle = (availableAppointments: AvailableAppointment[]): string => {
	if (!availableAppointments?.length) {
		return '';
	}
	return monthYearRange(availableAppointments[0].date, availableAppointments[availableAppointments.length - 1].date);
};

export const getSchedulerPayload = (leadFormData: any, selectedDate: string, selectedTime: Time): any => {
	return {
		lead: {
			first_name: leadFormData.firstName,
			last_name: leadFormData.lastName,
			phone: leadFormData.phone,
			email: leadFormData.email,
		},
		appointment: {
			date: selectedDate,
			time: selectedTime.date_time_local,
		},
	};
};
